export default __webpack_public_path__ + "static/media/icon-algostudy-n.f7c8115a.webp";